import { type FeatureRegistry, FlowSubmissionIdempotencyToken } from '@betterment/js-runtime';

export const featureRegistry: FeatureRegistry = {
  signablePackage: {
    CapturePackageSignature: {
      idempotencyToken: FlowSubmissionIdempotencyToken,
    },
    ForwardSignature: {
      idempotencyToken: FlowSubmissionIdempotencyToken,
    },
    ReclaimPackageSignature: {
      idempotencyToken: FlowSubmissionIdempotencyToken,
    },
  },
};
